import React from 'react';
import { Grid, Container } from '@mui/material';
import Intro from './Intro';
import Content from './Content';
import About from './About';
import MetaCard from './MetaCard';

function Info({ course }) {
    return (
        <Container sx={{ py: 4 }}>
            <Grid container spacing={4}>
                {/* Left Section */}
                <Grid item xs={12} md={8}>
                    <Intro learningOutcomes={course.learningOutcomes || []} />
                    <Content outline={course.outline} />
                    <About
                        requirements={course.requirements || []}
                        certificateEnabled={course.certificateEnabled}
                        instructor={course.instructor || {}}
                    />
                </Grid>

                {/* Right Section */}
                <Grid item xs={12} md={4}>
                    <MetaCard
                        lessons={course.lessons || "N/A"}
                        duration={course.duration || "N/A"}
                        certificateEnabled={course.certificateEnabled || false}
                        accessType={course.accessType || "Not available"}
                    />
                </Grid>
            </Grid>
        </Container>
    );
}

export default Info;
